import { ProspectsType } from "../models/prospects.model";
import ResourceFactory from "./resource";

const resourceKey = "prospects";
const resourceUrl = "prospects";
const resourceIdKey = "id";

const { reducer, fetchList, fetch, create, update, remove } = ResourceFactory<ProspectsType>(
  resourceKey,
  resourceUrl,
  resourceIdKey,
);

export type ProspectResourcesState = ReturnType<typeof reducer>;
export const fetchProspectsList = fetchList;
export const fetchProspect = fetch;
export const createProspect = create;
export const updateProspect = update;
export const removeProspect = remove;
export default reducer;
